import React from "react";
import Card from "../../newComponents/card";

const Office = ({ block }) => {
  
  const office = block.relatedOffice[0];
  const staffContact = block.relatedOffice[0].officeRelatedContact[0];
  // let strippedString = originalString.replace(/(<([^>]+)>)/gi, "");

  if (!staffContact) {
    return <></>
  }

  return (
    <section>
      <div className="shell">
        <div className="mb-2 mt-2 border-solid border-0 border-b border-gray-200">
          <h3 className="h3 pb-3">{office.title}</h3>
          <div className={`grid grid-cols-12 gap-2 mb-2`}>
            <div className="col-span-12 md:col-span-8">
              <div className="aspect-w-16 aspect-h-11">
              <iframe title="Office Map" src={office.officeMap.url} style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"/>

              </div>
            </div>
            <div className="col-span-12 md:col-span-4">
              <Card key={staffContact.displayTitle} ar={1/1} image={staffContact.featureImage[0]} standalone={true} readMoreLabel="Email" title={staffContact.displayTitle} href={`mailto:${office.officeEmail}`} subtitle={staffContact.position} />
            </div>
          </div>
          {office.officeSwitchboard && <p><strong>Switchboard:</strong> {office.officeSwitchboard}</p>}
          {office.officePhysicalAddress && <p><strong>Physical address:</strong> {office.officePhysicalAddress}</p>}
          {office.officePostalAddress && <p><strong>Postal address:</strong> {office.officePostalAddress}</p>}
          <p><strong>Contact:</strong> {office.officeRelatedContact[0].displayTitle} <a href={`mailto:${office.officeEmail}`}>{office.officeEmail}</a></p>
          <br/>
        </div>
      </div>
    </section>    
  );
}

export default Office;